<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { IcArrowRight } from '@xpos/icons-svg';

export interface OutLet {
    uid: string;
    name: string;
    postcode: string;
    address: string;
    taxNumber: string;
    api_key: string;
    vault: string;
    logo_image_url?: string;
    subdomain?: string;
}

export default defineComponent({
    name: 'OutletListSelector',
    components: {
        IcArrowRight,
    },
    props: {
        outlets: {
            type: Array as PropType<OutLet[]>,
            required: true,
            default: () => [],
        },
        height: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['select'],
    setup(props) {
        const listMaxHeight = computed(() => props.height || 'auto');
        return { listMaxHeight };
    },
});
</script>

<template>
    <div class="outlet-list-container">
        <div class="outlet-list" :style="{ maxHeight: listMaxHeight }">
            <div v-for="outlet in outlets" :key="outlet.uid" class="outlet-item" @click="$emit('select', outlet)">
                <div class="outlet-info">
                    <div class="outlet-avatar">
                        <img v-if="outlet.logo_image_url" :src="outlet.logo_image_url" :alt="outlet.name" />
                        <span v-else>{{ outlet.name.substring(0, 2) }}</span>
                    </div>
                    <div class="outlet-details">
                        <div class="outlet-name">{{ outlet.name }}</div>
                        <div class="outlet-address">{{ outlet.address || outlet.postcode }}</div>
                    </div>
                </div>
                <div class="outlet-arrow">
                    <el-icon color="#3A3A3A" size="30">
                        <IcArrowRight />
                    </el-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.outlet-list-container { height: 100%; }
.outlet-list {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
}
.outlet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  margin-bottom: 8px;
  height: 60px;
  background: #FFF;
  border: 1px solid #A8A8A8;
  box-shadow: 0 4px 4px rgba(0,0,0,.05);
  border-radius: 10px;
  cursor: pointer;
}
.outlet-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}
.outlet-avatar {
  width: 50px;
  height: 50px;
  border: 1px solid #F3F3F3;
  border-radius: 50%;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  img { width: 100%; height: 100%; object-fit: cover; }
  span { font: 500 20px/1 'Barlow',sans-serif; color: #000; }
}
.outlet-details {
  flex: 1;
  min-width: 0;
  .outlet-name,
  .outlet-address { font: 500 14px/130% 'Barlow',sans-serif; }
  .outlet-name { color: #3A3A3A; }
  .outlet-address {
    color: #52599D;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
}
.outlet-arrow {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #3A3A3A;
}
</style>
